// Placeholders that hold the shape of what is loading.
//
// The screens used to render their empty state while the first request was in
// flight, so opening a folder flashed "No boards in this folder" for a moment
// before the boards appeared. An empty state is an answer, and showing it before
// there is an answer is wrong. Nothing renders a verdict now until the data has
// arrived; until then these hold the layout still.

export const Skeleton = ({ width = "100%", height = 14, radius = 6, style }) => (
  <span
    className="skeleton"
    aria-hidden="true"
    style={{ width, height, borderRadius: radius, ...style }}
  />
);

/** Rows shaped like the board list, so the page does not jump when they land. */
export const BoardRowsSkeleton = ({ rows = 3 }) => (
  <div className="board-table" aria-busy="true" aria-label="Loading boards">
    {Array.from({ length: rows }, (_, i) => (
      <div className="board-row" key={i}>
        <Skeleton width={46} height={34} radius={6} />
        <div className="board-cell stack" style={{ gap: 6 }}>
          <Skeleton width={`${55 - i * 8}%`} height={13} />
          <Skeleton width="32%" height={10} />
        </div>
        <div className="board-cell col-tags">
          <Skeleton width="46%" height={12} radius={999} />
        </div>
        <div className="board-cell col-creator row" style={{ gap: 8 }}>
          <Skeleton width={22} height={22} radius={999} />
          <Skeleton width="58%" height={12} />
        </div>
        <Skeleton width={52} height={12} style={{ marginLeft: "auto" }} />
        <span />
      </div>
    ))}
  </div>
);

export const FolderCardsSkeleton = ({ cards = 2 }) => (
  <div className="folder-grid" aria-busy="true" aria-label="Loading folders">
    {Array.from({ length: cards }, (_, i) => (
      <div className="folder-card" key={i}>
        <Skeleton width={26} height={21} radius={4} />
        <div className="stack" style={{ flex: 1, gap: 6 }}>
          <Skeleton width={`${70 - i * 15}%`} height={13} />
          <Skeleton width="40%" height={10} />
        </div>
      </div>
    ))}
  </div>
);

export const PanelRowsSkeleton = ({ rows = 2 }) => (
  <div aria-busy="true">
    {Array.from({ length: rows }, (_, i) => (
      <div className="board-row" key={i} style={{ gridTemplateColumns: "32px minmax(0,2fr) 110px" }}>
        <Skeleton width={30} height={30} radius={999} />
        <div className="stack" style={{ gap: 6 }}>
          <Skeleton width={`${50 - i * 10}%`} height={13} />
          <Skeleton width="38%" height={10} />
        </div>
        <Skeleton width={62} height={18} radius={999} />
      </div>
    ))}
  </div>
);
